import { ChangeDetectionStrategy, Component, computed, inject, ViewEncapsulation } from "@angular/core";
import { S25Util } from "../../../../util/s25-util";
import { LayoutWidget } from "../../layouts/se.layout.widget.abstract";
import { Layouts } from "../../layouts/se.layouts";
import { SeOrgDetailsStore } from "../se.org.details.store";
import { SeContactTileComponent } from "../se.contact.tile.component";

@Component({
    standalone: true,
    selector: "s25-ng-se-org-primary-contact-widget",
    template: `
        @if (orgStore.primaryContact(); as contact) {
            <se-contact-tile
                [name]="contact.itemName"
                [email]="contact.itemEmail"
                [contactId]="contactId()"
                [header]="'Primary Contact'"
            />
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.Emulated,
    imports: [SeContactTileComponent],
})
export class SeOrgPrimaryContactWidgetComponent extends LayoutWidget<typeof SeOrgPrimaryContactWidgetComponent> {
    static readonly META = {
        name: "Primary Contact",
        info: "Displays the organization's primary contact.",
        settings: [],
        defaultSettings: {},
    } as const satisfies Layouts.WidgetStatic;

    protected readonly orgStore = inject(SeOrgDetailsStore);
    protected readonly contactId = computed(() => S25Util.parseInt(this.orgStore.primaryContact()?.itemId));
}
